export const Link = ({ width = '21', height = '20', fill = '#121212' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.97186 9.42136L4.81457 8.57864C5.20707 8.18615 5.84343 8.18615 6.23593 8.57864C6.60039 8.9431 6.62643 9.51784 6.31403 9.91234L6.23593 10L5.39322 10.8427C4.21573 12.0202 4.21573 13.9293 5.39322 15.1068C6.52866 16.2422 8.34437 16.2828 9.5284 15.2284L9.65729 15.1068L10.5 14.2641C10.8925 13.8716 11.5289 13.8716 11.9214 14.2641C12.2858 14.6285 12.3119 15.2033 11.9995 15.5978L11.9214 15.6854L11.0786 16.5281C9.11616 18.4906 5.93435 18.4906 3.97186 16.5281C2.06102 14.6173 2.01074 11.5505 3.82101 9.57878L3.97186 9.42136ZM9.92136 3.47186C11.8838 1.50938 15.0657 1.50938 17.0281 3.47186C18.9906 5.43435 18.9906 8.61616 17.0281 10.5786L16.1854 11.4214C15.7929 11.8139 15.1566 11.8139 14.7641 11.4214C14.3716 11.0289 14.3716 10.3925 14.7641 10L15.6068 9.15729C16.7843 7.9798 16.7843 6.07071 15.6068 4.89322C14.4293 3.71573 12.5202 3.71573 11.3427 4.89322L10.5 5.73593C10.1075 6.12843 9.47114 6.12843 9.07864 5.73593C8.68615 5.34343 8.68615 4.70707 9.07864 4.31457L9.92136 3.47186ZM10.9214 8.15729C11.3139 7.76479 11.9502 7.76479 12.3427 8.15729C12.7352 8.54978 12.7352 9.18615 12.3427 9.57864L10.0786 11.8427C9.68615 12.2352 9.04978 12.2352 8.65729 11.8427C8.26479 11.4502 8.26479 10.8139 8.65729 10.4214L10.9214 8.15729Z"
        fill={fill}
      />
    </svg>
  );
};
